// Core
import React, { useState, useEffect, useRef } from "react";
import { FileUploader } from "react-drag-drop-files";
import { AiOutlineDelete } from "react-icons/ai";
import { MdDeleteOutline } from "react-icons/md";
import { useDispatch } from "react-redux";
import { getDropDownData } from "../../Redux/Slices/Accessor/accessorSlice";
import Dropdown from "Components/Dropdown";
// Styles
import "./styles.scss";

// Assets
import uploadIcon from "../../Assets/Images/uploadIcon.svg";

// Custom component
import InputBox from "Components/InputBox";
import { useSelector } from "react-redux";
import { multiUpload } from "../../Redux/Slices/User/userSlice";
import Loader from "Components/Loader";
import Button from "Components/Button";
import { compressImage } from "Services/Utils/imageCompression";
const SparePartLogo = ({
  isOne,
  index,
  AddAnotherSparePart,
  handleDelete,
  uploadError,
  setUploadError,
  files,
  setFiles,
  partType,
  setPartType,
  partNumber,
  setPartNumber,
  currentBrand,
  setCurrentBrand,
  applicationArea,
  setApplicationArea,
  operatingCondition,
  setOperationgCondition,
  issuesFaced,
  setIssuesFaced,
  onModuleSelect,
  productOptions,
  setModuleOptions,
  previewReady,
  onProductSelect,
}) => {
  const sparePartStyle = {
    border: "1px solid #858485",
    borderRadius: "4px",
    height: "49px",
    outline: "none",
    fontSize: "14px",
    fontWeight: "400",
  };

  const textAreaStyle = {
    ...sparePartStyle,
    minHeight: "78px",
    paddingTop: "10px",
    paddingBottom: "10px",
    resize: "none",
    overflow: "hidden",
  };

  const sparePartTitle = {
    color: "#2E2E2E",
    fontWeight: "600",
    fontSize: "16px",
  };

  const inputStyle = {
    borderWidth: 1,
    borderColor: "grey",
    fontSize: 13,
    backgroundColor: "white",
    color: "black",
    height: 49,
    boxShadow: "none",
  };

  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.user.isLoading);
  const [dropdownData, setDropdownData] = useState([]);
  const [formattedOptions, setFormattedOptions] = useState([]);
  const [showOtherProduct, setShowOtherProduct] = useState(false);
  const [manualApplicationArea, setManualApplicationArea] = useState("");
  const isModuleSelected = partType ? true : false;
  const canDeleteProduct = partType && manualApplicationArea;
  const textAreaRef = useRef(null);


  const dropdownStyle = {
    width: "100%",
    marginBottom: "10px",
    color: "black",
    borderRadius: "2px",
  };

  const dropdownOption = {

  }

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = "auto";
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
    }
  }, []);

  useEffect(() => {
    dispatch(getDropDownData())
      .unwrap()
      .then((response) => {
        if (Array.isArray(response.data)) {
          const options = response.data.map((item) => ({
            label: item.module_name,
            value: item.module_name,
            id: item.module_id,
          }));
          setFormattedOptions(options);
          setModuleOptions(options)

          if (previewReady) {
            previewReady(options)
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching dropdown data:", error);
      });
  }, [dispatch]);


  const handleModuleChange = (e) => {
    const value = e.target.value;
    const selectedModule = formattedOptions.find(
      (it) => it?.label === value
    );

    const moduleId = selectedModule?.id || null;

    onModuleSelect(index, value, moduleId);
  };



  const handleFileChange = async (file) => {
    const validExtensions = [".png", ".jpg", ".jpeg"];
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB
    const compressedFiles = [];

    let error = "";
    const selectedFiles = Array.from(file);

    for (const file of selectedFiles) {
      const extension = "." + file.name.split('.').pop().toLowerCase();

      if (!validExtensions.includes(extension)) {
        error = "Invalid file type. Only .png, .jpg, .jpeg files are allowed.";
      }
      let finalFile = file;

      if (file.type.startsWith("image/") && file.size > 1024 * 1024 && file.size < MAX_FILE_SIZE) {
        const compressedBlob = await compressImage(file, 1);
        finalFile = new File([compressedBlob], file.name, {
          type: compressedBlob.type,
          lastModified: Date.now(),
        });
      }
      if (file.size > MAX_FILE_SIZE) {
        error = `File ${file.name} exceeds the 5 MB size limit.`;
        break
      }
      compressedFiles.push(finalFile);
    };

    if (error) {
      setUploadError(error);
      return;
    }

    setUploadError("");
    const formData = new FormData();
    compressedFiles.forEach((file) => {
      formData.append("files", file);
    });

    dispatch(
      multiUpload({
        files: formData,
        callBack: (uploadedFiles) => {
          const newFiles = Array.isArray(uploadedFiles) ? uploadedFiles : [uploadedFiles];
          const fileData = newFiles.map(file => ({
            name: file.originalName || file.name,
            url: file.url
          }));
          // Ensure we maintain the existing files array structure
          const updatedFiles = [...files, ...fileData];
          setFiles(updatedFiles);
        },
      })
    );
  };

  const handleRemoveFile = (fileToRemove) => {
    const updatedFiles = files.filter(file => {
      const fileUrl = typeof file === 'string' ? file : file.url;
      const removeUrl = typeof fileToRemove === 'string' ? fileToRemove : fileToRemove.url;
      return fileUrl !== removeUrl;
    });
    setFiles(updatedFiles);
  };

  const handleDeleteProduct = () => {
    setShowOtherProduct(false);
    setManualApplicationArea("");
    setApplicationArea("");
    setFiles([]);
    onProductSelect(index, "");
  };


  useEffect(() => {
    if (showOtherProduct) {
      setApplicationArea(manualApplicationArea);
    }
  }, [manualApplicationArea, showOtherProduct]);



  return (
    <>
      <div className="sparePartsLogoWrap mx-3 my-4">
        <div className="sparePartsLabel">
          <label>KG Product Offerings</label>
          <div>
            <Button
              onClick={AddAnotherSparePart}
              title="Add"
              titleStyle={{ fontSize: "14px", fontWeight: "600" }}
              buttonStyle={{ padding: "8px 15px" }}
            />
            {index !== 0 && (
              <MdDeleteOutline
                onClick={handleDelete}
                size={25}
                className="removeIcon"
              />
            )}
          </div>
        </div>
        <div className="sparePartsLogoContWrap my-3 py-5 px-4">
          <div className="row">
            <div className="col-6 my-3">
              <Dropdown
                label="Module Name"
                name="module_name"
                value={partType}
                options={formattedOptions}
                onChange={handleModuleChange}
                dropdownStyle={dropdownStyle}
                labelStyle={sparePartTitle}
                inputStyle={inputStyle} />
            </div>
            <div className="col-6 my-3">

              <Dropdown
                label="Product Name"
                name="product_name"
                value={showOtherProduct ? "" : applicationArea}
                options={
                  productOptions[index]?.length
                    ? productOptions[index]
                    : [{ label: "No options", value: "" }]
                }
                onChange={(e) => {
                  if (showOtherProduct) return;
                  setApplicationArea(e.target.value);
                  onProductSelect(index, e.target.value);
                  setShowOtherProduct(false);
                }}
                dropdownStyle={{
                  ...dropdownStyle,
                  opacity: showOtherProduct ? 0.6 : 1,
                  pointerEvents: showOtherProduct ? "none" : "auto",
                }}
                labelStyle={sparePartTitle}
                inputStyle={inputStyle}
              />

              <div className="product-row">
                <span style={{ fontSize: "14px" }}>Product not found? Add manually</span>

                <Button
                  title="Add"
                  buttonStyle={{
                    padding: "2px 10px",
                    backgroundColor: "#1f2155",
                    border: "solid 1px grey",
                    height: "51px",
                    width: "150px",
                    cursor: isModuleSelected ? "pointer" : "not-allowed",
                    opacity: isModuleSelected ? 1 : 0.6,
                  }}
                  titleStyle={{ fontSize: "16px", color: "white" }}
                  disabled={!isModuleSelected}
                  onClick={() => {
                    if (!isModuleSelected) return;
                    setShowOtherProduct(true);
                    setManualApplicationArea("");
                    setApplicationArea("");
                    setFiles([]);;
                  }}
                />

                <Button
                  title="Delete"
                  disabled={!canDeleteProduct}
                  buttonStyle={{
                    padding: "2px 10px",
                    backgroundColor: "#1f2155",
                    border: "solid 1px grey",
                    height: "51px",
                    width: "150px",
                    cursor: canDeleteProduct ? "pointer" : "not-allowed",
                    opacity: canDeleteProduct ? 1 : 0.6,
                  }}
                  titleStyle={{ fontSize: "16px", color: "white" }}
                  onClick={handleDeleteProduct}
                />


              </div>


            </div>
            {showOtherProduct && (
              <div className="col-12 my-3">
                <InputBox
                  label="Other Product Name"
                  value={manualApplicationArea}
                  inputStyle={sparePartStyle}
                  labelStyle={sparePartTitle}
                  onChange={(e) => {
                    const value = e.target.value;
                    setManualApplicationArea(value);
                  }}
                  placeholder="Enter product name"
                />
              </div>
            )}
            <div className="col-12">
              <InputBox
                label="Recommendations"
                inputStyle={textAreaStyle}
                labelStyle={sparePartTitle}
                value={issuesFaced}
                onChange={(e) => {
                  setIssuesFaced(e.target.value)
                  if (e.target.classList.contains("auto-grow-textarea")) {
                    e.target.style.height = "auto";
                    e.target.style.height = `${e.target.scrollHeight}px`;
                  }
                }}
                type="textarea"
                className="auto-grow-textarea"
                ref={textAreaRef}
              />
            </div>
            <div className="col-12">
              <InputBox
                label="Priority"
                type={"tel"}
                maxLength="2"
                placeholder="Enter a number (1-10)"
                inputStyle={sparePartStyle}
                labelStyle={sparePartTitle}
                value={partNumber}
                onChange={(e) => {
                  const value = e.target.value;
                  //value is between 0 and 10
                  if (value === '' || (Number(value) >= 0 && Number(value) <= 10)) {
                    setPartNumber(value);
                  }
                }}
              />
            </div>
          </div>
          <div>
            <div className="my-3">
              <label className="uploadLabel">Upload Photos</label>
              <div className="filess">
                {isLoading === "loading" ? (
                  <Loader />
                ) : (
                  <FileUploader
                    handleChange={handleFileChange}
                    name="file"
                    multiple
                    classes="drop_area drop_zone"
                  >
                    <p className="drag">
                      <span className="mx-2 my-1">
                        <img src={uploadIcon} alt="upload" />
                      </span>
                      Drag your file here or upload to{" "}
                      <span className="here mx-2">Browse</span>
                    </p>
                  </FileUploader>)}
                <div className="my-2 uploadNote">
                  Note: Only images (JPG, PNG, JPEG) are allowed. File size must not exceed 5MB.
                </div>
                {uploadError !== "" && (
                  <span className="text-danger fs-13 fw-500">
                    {uploadError}
                  </span>
                )}
              </div>
              <div className="uploaded-file-list">
                {Array.isArray(files) && files.length > 0 ? (
                  files.map((file, index) => (
                    <div key={index}>
                      <div className="uploaded-file-name">
                        {typeof file === "string"
                          ? file.split("/").pop()
                          : file.name || file.url.split("/").pop()}
                        <AiOutlineDelete
                          className="remove-icon"
                          onClick={() => handleRemoveFile(file)}
                          style={{ cursor: "pointer", marginLeft: "8px" }}
                          color="#1f2155"
                          size={25}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No files uploaded yet.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SparePartLogo;
